import { render } from "./Filler.vue?vue&type=template&id=4475f7e7&scoped=true"
import script from "./Filler.vue?vue&type=script&lang=ts"
export * from "./Filler.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4475f7e7"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
